<div [formGroup]="formGroupRGPD" class="dialog-default">
  <h1 class="h1" mat-dialog-title><u>Droits et autorisations</u></h1>
  <mat-dialog-content class="mat-typography">
    <hr>
    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title class="h5">Clause RGPD</mat-panel-title>
        <mat-panel-description>
          Détails
        </mat-panel-description>
      </mat-expansion-panel-header>

      <p>L’adhérent et le cas échéant, son représentant légal, est informé que l’Association SPORT DANS LA VILLE
        traite
        les données personnelles de ses membres dans la limite de ce qui est strictement nécessaire à l’exercice
        de
        son
        objet social.</p>
      <br>

      <p>L’Association SPORT DANS LA VILLE est, au sens du Règlement UE 2016/679, responsable du traitement
        qu’elle
        opère
        des données personnelles qu’elle recueille dans les conditions décrites ci-dessous.</p>
      <br>

      <p class="tabulation">1. Le traitement des données personnelles est réalisé afin d’enregistrer l’adhérent au
        sein de
        l’Association SPORT DANS LA VILLE et la bonne exécution des actions qu’elle s’engage à menées à l’égard
        de
        l’adhérent et plus généralement dans le cadre de l’exercice de son objet social.</p>
      <br>

      <p>L’Association SPORT DANS LA VILLE collecte, dans la limite de ce qui est strictement nécessaire à
        l’exécution
        dudit contrat, les données personnelles suivantes : Nom Et Prénom de l’adhérent, Date De Naissance, Nom
        Et
        Prénom
        du Représentant Legal Le Cas Echéant, Adresse Postale, Adresse E-Mail, Téléphone, Situation Familiale,
        Etudes,
        Profession, et toutes les informations personnelles strictement nécessaires au suivi et à
        l’accompagnement
        du
        jeune dans son parcours scolaire et professionnel.</p>
      <br>

      <p>A défaut de disposer de ces informations, l’Association SPORT DANS LA VILLE ne pourra pas mettre en œuvre
        les
        actions auxquelles l’Adhérent souhaite participer.</p>
      <br>

      <p>Le traitement de ces données peut également être réalisé aux fins d’adresser à l’Adhérent les
        propositions
        d’activités, les informations sur l’actualité de l’Association SPORT DANS LA VILLE et ses actions, sous
        réserve
        que l’Adhérent y ait consenti lors de son adhésion en cochant la case à cet effet.</p>
      <br>

      <p class="tabulation">2. Pour la majorité des données collectées, la durée de conservation est de 1 an à
        compter
        du
        terme de l’adhésion de l’Adhérent à l’Association SPORT DANS LA VILLE. Ces données pourront ensuite être
        archivées
        pendant une durée supplémentaire de 2 ans afin de préserver les droits de chacune des Parties.</p>
      <br>

      <p>A la demande de certains de nos financeurs publics, comme le Fonds Social Européen, certaines données
        pourront
        être conservées 10 ans à compter du terme de l’adhésion de l’Adhérent à l’Association SPORT DANS LA
        VILLE ;
        ceci
        concerne principalement les adhérents qui souscrivent également au programme Job dans la Ville d’aide à
        l’insertion professionnelle. Ces données sont conservées dans un but de suivi et de rendus auprès de nos
        différents financeurs publics et privés.</p>
      <br>

      <div class="tabulation">
        <p>3. Seuls seront (ou pourront être) destinataires des données personnelles :</p>
        <p>- L’Association SPORT DANS LA VILLE ;</p>
        <p>- Son prestataire informatique en charge des opérations de traitement des données personnelles ;</p>
        <p>- Ses prestataires en charge de certaines activités ou autres actions et ses mécènes et financeurs
          publics
          s’intégrant dans le cadre de l’exercice de l’objet social de l’Association SPORT DANS LA VILLE ;</p>
      </div>
      <br>

      <p>Les données personnelles traitées ne font pas l’objet d’un transfert hors Union-Européenne et sont
        stockées
        au
        sein de l’Union.</p>
      <br>

      <div class="tabulation">
        <p>4. Conformément à la règlementation relative à la protection des données personnelles (Règlement UE
          2016/679
          dit « RGPD), les personnes ont, sur les données personnelles les concernant :</p>
        <p>- Un droit d’accès aux données collectées ;</p>
        <p>- Un droit de rectification des données personnelles inexactes ;</p>
        <p>- Un droit à la limitation du traitement dans les conditions prévues à la section 3 du chapitre III
          du
          RGPD
          ;</p>
        <p>- Un droit à l’effacement dans les conditions prévues à la section 3 du chapitre III du RGPD;</p>
        <p>- Un droit à la portabilité ;</p>
        <p>- Un droit d’opposition au traitement dans les conditions prévues à la section 4 du chapitre III du
          RGPD
          ;</p>
        <p>- Un droit de ne pas faire l’objet d’un traitement automatisé dans les conditions prévues à la
          section 4
          du
          chapitre III du RGPD ;</p>
        <p>- Un droit de porter réclamation auprès de l’autorité nationale de contrôle, savoir la CNIL.</p>
      </div>
      <br>

      <p>Toute personne peut exercer ses droits en s’adressant, le cas échéant, à l’Association SPORT DANS LA
        VILLE
        aux
        coordonnées suivantes : Association SPORT DANS LA VILLE 15 quai de la Gare d’Eau, 69009 Lyon ou à
        l’adresse
        mail
        <u>contact&#64;sportdanslaville.com</u>.</p>
    </mat-expansion-panel>

    <mat-checkbox color="primary" formControlName="isRGPDReaded">
      Je soussigné(e),
      <ng-container *ngIf="isMinor">
        {{ legalResponsibleName }} responsable de l’enfant
      </ng-container>
      {{ youngName }}, reconnais avoir lu et accepté les clauses RGPD.
    </mat-checkbox>
    <hr>

    @if (isMinor) {
      <mat-expansion-panel class="mat-elevation-z0">
        <mat-expansion-panel-header>
          <mat-panel-title class="h5">Droit à rentrer seul</mat-panel-title>
          <mat-panel-description>
            Détails
          </mat-panel-description>
        </mat-expansion-panel-header>

        <p>Sport dans la Ville, au travers de ses différents programmes, propose tout au long de l’année des activités
          (séances sportives, ateliers, visites d’entreprises, sorties sportives, sorties culturelles, évènements
          emplois/réseau, etc.). Ces activités ont pour objectif de favoriser le développement personnel et
          professionnel de votre enfant. Ces activités peuvent être proposées pendant la journée ou en soirée, le
          week-end, ou pendant les vacances scolaires.</p>
      </mat-expansion-panel>

      <mat-checkbox color="primary" formControlName="canComeAlone">
        Je soussigné(e) {{ legalResponsibleName }} autorise, pour toute l’année, mon enfant {{ youngName }} à rentrer
        seul(e) après chaque activité organisée par Sport dans la Ville.
      </mat-checkbox>
      <br/>
      <br/>
      <mat-checkbox color="primary" formControlName="cantComeAlone">
        Je soussigné(e) {{ legalResponsibleName }} n’autorise pas mon enfant {{ youngName }} à rentrer seul(e) après
        chaque activité
        organisée par Sport dans la Ville ET je m’engage à venir systématiquement le/la récupérer au point de rencontre
        fixé, à l’heure de fin de l’activité.
      </mat-checkbox>

      <hr>
    }

    <mat-expansion-panel class="mat-elevation-z0">
      <mat-expansion-panel-header>
        <mat-panel-title class="h5">Droit à l’image</mat-panel-title>
        <mat-panel-description>
          Détails
        </mat-panel-description>
      </mat-expansion-panel-header>
      <!--    mineur-->

      <div *ngIf="isMinor; else majeur">
        <p>Dans un objectif d’information et de communication, j’autorise l’Association Sport dans la Ville à
          photographier, enregistrer et filmer mon enfant ({{ young.lastname }} {{ young.firstname }}) dans le
          cadre
          des
          activités de l’Association, à reproduire, diffuser et publier l’image, le nom, la voix, dans le
          monde
          entier,
          sur tous les supports et formats actuels et à venir. Ces éléments peuvent, notamment, être diffusés
          sur
          les
          sites Internet et les réseaux sociaux de l’Association Sport dans la Ville, ainsi que sur les
          comptes
          des
          équipes de l’Association, sur support papier, et télédiffusés.</p>
        <br>

        <p>Certaines photos, enregistrements ou films pourront être utilisées par l’Association Sport dans la
          Ville
          ou par
          des partenaires publics ou privés financeurs de l’Association pour un usage strictement non
          commercial,
          à des
          fins de communication sur les actions de l’Association Sport dans la Ville.</p>
        <br>

        <p>L’autorisation de photographier ou de filmer mon enfant est valable tant que celui-ci est inscrit à
          l’association</p>
        <br>

        <p>L’autorisation de reproduction, diffusion et publication de l’image de mon enfant est valable à
          compter
          de la
          date de la prise de vue (photographie, enregistrement, film), pour une durée de trois ans même si
          mon
          enfant est
          amené à quitter l’Association Sport dans la Ville</p>
        <br>

        <p>Je renonce à toute forme de rémunération ainsi qu’à tout recours ou poursuite de quelque nature que
          ce
          soit
          contre l’Association Sport dans la Ville au titre des autorisations données.</p>
        <br>


      </div>

      <!--    majeur-->

      <ng-template #majeur>
        <p>Dans un objectif d’information et de communication, j’autorise l’Association Sport dans la Ville à me
          photographier, m’enregistrer et me filmer dans le cadre des activités de l’association, à
          reproduire,
          diffuser
          et publier mon image, mon nom, ma voix, dans le monde entier, sur tous les supports actuels et à
          venir.
          Ces
          éléments peuvent, notamment, être diffusés sur les sites Internet et les réseaux sociaux de
          l’Association Sport
          dans la Ville ainsi que sur les comptes des équipes de l’Association, sur support papier, et
          télédiffusés.</p>
        <br>

        <p>Certaines photos, enregistrements ou films pourront être utilisées par l’Association Sport dans la
          Ville
          ou par
          des partenaires publics ou privés financeurs de l’Association pour un usage strictement non
          commercial,
          à des
          fins de communication sur les actions de l’Association Sport dans la Ville.</p>
        <br>

        <p>L’autorisation de me photographier ou de me filmer est valable tant que je suis inscrit à
          l’association.</p>
        <br>

        <p>L’autorisation de reproduction, diffusion et publication de mon image est valable à compter de la
          date de
          la
          prise de vue (photographie, enregistrement, film), pour une durée de trois ans même si je suis amené
          à
          quitter
          l’Association Sport dans la Ville.</p>
        <br>

        <p>Je renonce à toute forme de rémunération ainsi qu’à tout recours ou poursuite de quelque nature que
          ce
          soit
          contre l’Association Sport dans la Ville au titre des autorisations données.</p>
        <br>
      </ng-template>
    </mat-expansion-panel>

    <mat-checkbox color="primary" formControlName="canTakePhotos">
      Je soussigné(e),
      <ng-container *ngIf="isMinor">
        {{ legalResponsibleName }} responsable de l’enfant
      </ng-container>
      {{ youngName }}, reconnais avoir lu et accepté les
      autorisations de droit à l'image.
    </mat-checkbox>


    <hr>

    <p class="h5">Droit de contact</p>
    <br>

    <mat-checkbox color="primary" formControlName="canContactResponsable">Je
      déclare accepter être contacté et recevoir
      des informations de la part de Sport dans la Ville dans l’objectif du bon déroulement des activités et
      différentes
      sorties.
    </mat-checkbox>

  </mat-dialog-content>


  <mat-dialog-actions class="d-flex flex-row justify-content-center">
    <button (click)="closePopup()" class="btn btn-secondary my-2 mx-2" type="button">Fermer</button>
    <button (click)="updateRights()" class="btn btn-primary my-2 mx-2" type="button">Valider</button>
  </mat-dialog-actions>
</div>
